import VerifyPage from "./VerifyPage";

export default VerifyPage;
